import * as React from 'react';

import Alert from 'src/components/common/Alert';

import locationServiceInstance from 'src/services/location/LocationService';
import env from 'src/shared/env';

import './DeliverAddressChange.scss';
import i18n from 'src/translation/i18n';

interface IDeliverAddress {
  warehouseCode: string;
  description: string;
  quantity: number;
  name: string;
  code: string;
  addressLine1: string;
  addressLine2: string;
  addressLine4: string;
  stateCode: string;
  postalCode: string;
  pickUpOnly: boolean;
}

interface IDeliverAddressChangeProps {
  deliverAddresses: IDeliverAddress[];
  defaultWarehouse: any;
  supplierQuantity: number;
  showPickUpOnly: boolean;
  type: 'shipping' | 'pick-up' | '';
  buttonVerbiage: string;
  selectedAddresses: object;
  selectedPartState: string;
  selectedPartQty: number;
  deliveryLocationCode: string;
  handleClose: () => void;
  handleChangeAddress: (selectedAddresses: object) => void;
  t?: any;
}

interface IDeliverAddressChangeState {
  selectedAddresses: object;
  zipCode: string;
  alert: { show: boolean; type: string; message: string };
}

class DeliverAddressChange extends React.Component<
  IDeliverAddressChangeProps,
  IDeliverAddressChangeState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      selectedAddresses: {},
      zipCode: '',
      alert: { show: false, type: '', message: '' }
    };
  }

  private handleOnInputChange = (
    warehouse: string,
    qty: string,
    available: number
  ) => {
    const { t } = this.props;
    if (qty === '' || qty === '0') {
      const temp = { ...this.state.selectedAddresses };
      delete temp[warehouse];
      this.setState({
        selectedAddresses: temp
      });
    } else {
      if (Number(qty) > available) {
        this.setState({
          alert: {
            show: true,
            type: 'info',
            message:
              env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                ? `${i18n.t('common.itemsBackOrderedOnly')}`
                : `${Number(qty) -
                    available} item(s) will be backordered. We will ship them as soon as the stocks are available for shipment.`
          }
        });
      } else {
        this.setState({ alert: { show: false, type: '', message: '' } });
      }
      this.setState(prevState => {
        return {
          selectedAddresses: {
            ...prevState.selectedAddresses,
            [warehouse]: { qty, available }
          }
        };
      });
    }
  };

  private handleCloseAlert = () => {
    this.setState({ alert: { show: false, type: '', message: '' } });
  };

  private formatAddress = (address: IDeliverAddress) => {
    let addressF: string = '';
    addressF +=
      address.addressLine1 && `${address.addressLine1.toLocaleLowerCase()} `;
    addressF +=
      address.addressLine2 && `${address.addressLine2.toLocaleLowerCase()} `;
    addressF +=
      address.addressLine4 && `${address.addressLine4.toLocaleLowerCase()}, `;
    addressF += address.stateCode && `${address.stateCode} `;
    addressF += address.postalCode && `${address.postalCode}`;
    return addressF;
  };

  public componentDidMount() {
    this.setState({ selectedAddresses: this.props.selectedAddresses });
  }

  private getWarehouses() {
    let first = null;
    const middle: any = [];
    const final: any = [];

    this.props.deliverAddresses.forEach(deliverAddress => {
      if (
        this.props.type === 'pick-up' &&
        deliverAddress.warehouseCode === this.props.deliveryLocationCode
      ) {
        first = deliverAddress;
      } else if (
        Number(deliverAddress.quantity) !== 0 &&
        !deliverAddress.pickUpOnly
      ) {
        middle.push(deliverAddress);
      } else if (
        Number(deliverAddress.quantity) === 0 &&
        !deliverAddress.pickUpOnly
      ) {
        final.push(deliverAddress);
      }
    });

    return first ? [first, ...middle, ...final] : [...middle, ...final];
  }

  public render() {
    return (
      <div>
        {this.state.alert.show && (
          <Alert
            type={this.state.alert.type}
            styleClass={'rp-deliver-address-change--alert'}
            message={this.state.alert.message}
            icon={
              this.state.alert.type === 'error' ? 'rpds-error' : 'rpds-shipping'
            }
            handleCloseAlert={this.handleCloseAlert}
          />
        )}
        <div className="rp-deliver-address-change">
          <div className="rp-deliver-address-change--info">
            <span
              onClick={e => this.props.handleClose()}
              className="rpds-close rp-deliver-address-change--close-modal-icon"
            />
            <div className="rp-deliver-address-change--directions-text">
              {this.props.type === 'shipping'
                ? `${i18n.t('checkoutPage.chooseShipFromLocation')}:`
                : this.props.showPickUpOnly
                ? `${i18n.t('checkoutPage.chooseShipYourPickup')}:`
                : `${i18n.t('delivery.choseASuppliedFrom')}:`}
            </div>
            <div className="rp-deliver-address-change--addresses">
              <div className="rp-deliver-address-change--addresses--titles-desktop">
                <div className="rp-deliver-address-change--addresses--title-store-desktop">
                  {i18n.t('product.store')}
                </div>
                <div className="rp-deliver-address-change--addresses--title-availability-desktop">
                  {i18n.t('product.availability')}
                </div>
                <div className="rp-deliver-address-change--addresses--title-qty-desktop">
                  {i18n.t('myOrders.qty')}:
                </div>
              </div>
              {this.props.deliverAddresses.length > 0 &&
                this.getWarehouses().map(address => (
                  <div key={address.warehouseCode}>
                    <div className="rp-divider" />
                    <div className="rp-deliver-address-change--addresses--row">
                      <div className="rp-deliver-address-change--addresses--address">
                        <div className="rp-deliver-address-change--addresses--title-mobile">
                          {i18n.t('product.store')}
                        </div>
                        <div className="rp-deliver-address-change--addresses--address--state">
                          {env.REACT_APP_BASE_ENVIRONMENT === 'US'
                            ? address.name.split(' PICK UP ONLY')[0]
                            : address.name}
                        </div>
                        <div className="rp-deliver-address-change--addresses--address--complete">
                          {this.formatAddress(address)}
                        </div>
                      </div>
                      <div className="rp-deliver-address-change--addresses--stock">
                        <div className="rp-deliver-address-change--addresses--title-mobile">
                          {i18n.t('product.availability')}
                        </div>
                        <div>
                          {address.quantity > 0
                            ? `${address.quantity} ${i18n.t('common.inStock')}`
                            : `${i18n.t('common.outOfStock')}`}
                        </div>
                      </div>
                      <div className="rp-deliver-address-change--addresses--quantity">
                        <div className="rp-deliver-address-change--addresses--title-mobile">
                          {i18n.t('myOrders.qty')}:
                        </div>
                        {env.REACT_APP_BASE_ENVIRONMENT === 'CA' &&
                        this.props.type === 'shipping' &&
                        address.pickUpOnly ? (
                          <label
                            style={{
                              fontSize: '10px',
                              textAlign: 'right',
                              width: '100%'
                            }}
                          >
                            {i18n.t('common.pickUpOnly')}
                          </label>
                        ) : (
                          <input
                          disabled={this.props.selectedPartState === 'In Stock No Backorder' && address.quantity < 1 && true}
                            value={
                              this.state.selectedAddresses[
                                address.warehouseCode
                              ]
                                ? this.state.selectedAddresses[
                                    address.warehouseCode
                                  ].qty
                                : ''
                            }
                            onChange={e =>
                              this.handleOnInputChange(
                                address.warehouseCode,
                                e.target.value,
                                address.quantity
                              )
                            }
                          />
                          
                        )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="rp-deliver-address-change--supplier">
              {i18n.t('product.manufacturerQuantity')}
              <span className="rp-deliver-address-change--supplier-count">
                {this.props.supplierQuantity}
              </span>
            </div>
            <div className="rp-deliver-address-change--button">
              <button
                className="primary-button"
                onClick={e =>
                  this.props.handleChangeAddress(this.state.selectedAddresses)
                }
              >
                {this.props.buttonVerbiage}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DeliverAddressChange;
